import { useMemo } from "react"
import { Box, useTheme } from "@mui/material"
import { Link } from "react-router-dom"
import { PromotionCard } from "components/domains/promotions"
import { EmptyData } from "components/EmptyData"
import { useTranslation } from "providers/i18n"
import { PercentIcon } from "components/icons"
import { Carousel } from "../../components/Carousel/Carousel"
import { CarouselItem } from "../../components/Carousel"
import { Head } from "components/Head"
import { usePromotion } from "hooks/promotion/usePromotion"
import { getIcon } from "utils/icon"
import { useVenue } from "providers/venue"
import { VenueSelector } from "components/VenueSelector"

export const Promotions = () => {
  const { t } = useTranslation()
  const {
    viewingVenueStorePromotion,
    onChangeVenue,
    locationVenueId,
    venueFilter,
  } = usePromotion()
  const { venues, isMultiVenueProject } = useVenue()

  const theme = useTheme()
  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.promotions) || <PercentIcon />,
    [theme]
  )
  const { styleOverrides } = theme.components?.[`PromotionPage`] || {}
  const {
    root,
    carouselContainer,
    carousel,
    cardListContainer,
    emptyDataContainer,
  } = styleOverrides

  const { venueSelector } = theme.components[`AppMap`]?.styleOverrides || {}

  if (!viewingVenueStorePromotion || viewingVenueStorePromotion?.length === 0)
    return (
      <>
        <Head title={t("Promotions")} />
        <Box sx={emptyDataContainer}>
          <EmptyData
            icon={emptyIcon}
            primary={t("Coming soon")}
            secondary={t("Check Back Soon")}
          />
        </Box>
      </>
    )

  return (
    <>
      <Head title={t("Promotions")} />
      <Box sx={root}>
        <Box sx={cardListContainer}>
          {viewingVenueStorePromotion.map((promotion) => (
            <Link to={`/promotions/${promotion.id}`} key={promotion.id}>
              <PromotionCard size="large" promotion={promotion} />
            </Link>
          ))}
        </Box>
        <Box sx={carouselContainer}>
          {viewingVenueStorePromotion &&
          viewingVenueStorePromotion.length > 0 ? (
            <Carousel
              options={{
                type: "loop",
                padding: "25%",
                pagination: true,
                autoplay: true,
              }}
              sx={carousel}
            >
              {viewingVenueStorePromotion.map((promotion) => (
                <CarouselItem key={promotion.id}>
                  <Link to={`/promotions/${promotion.id}`}>
                    <PromotionCard promotion={promotion} />
                  </Link>
                </CarouselItem>
              ))}
            </Carousel>
          ) : (
            ""
          )}
        </Box>
        {isMultiVenueProject && (
          <Box sx={venueSelector}>
            <VenueSelector
              selectedVenue={venueFilter}
              venues={venues}
              onClickVenue={onChangeVenue}
              currentVenue={locationVenueId}
            />
          </Box>
        )}
      </Box>
    </>
  )
}
